import type { TSliceTableExtractions } from "../tableExtractions/sliceTableExtractions";
import type { SelectedColumn, TStateTableMappings } from "./sliceTableMappings";

type TExtractionsInfo =
    | {
          fileName: string;
          extractionId: number;
          sheetName: string;
          uploadedAt: string | undefined;
          uploadedBy: string | undefined;
          completedAt: string | null | undefined;
      }[]
    | null;

export const createSelectedColumnInfo =
    () =>
    (state: {
        extractionStatus: "draft" | "completed" | null;
        highlightedCell: TStateTableMappings["highlightedCell"];
        extractionsInfo: TExtractionsInfo;
        extractionStandardizedRowsLoaded: TSliceTableExtractions["extractionStandardizedRowsLoaded"];
        extractionStandardizedActiveColumns: TSliceTableExtractions["extractionStandardizedActiveColumns"];
    }): SelectedColumn | null => {
        if (state.extractionStatus !== "draft") return null;

        if (
            !state.highlightedCell ||
            !state.extractionsInfo ||
            !state.extractionStandardizedRowsLoaded ||
            !state.extractionStandardizedActiveColumns
        )
            return null;

        if (
            state.highlightedCell?.colId === "account" ||
            state.highlightedCell?.colId?.includes("total") === true ||
            state.highlightedCell?.colId === null
        ) {
            return null;
        }
        const currentUploadExtractionId =
            state.extractionStandardizedRowsLoaded?.extractionId;
        const columnGroup =
            state.extractionStandardizedRowsLoaded?.columnDefsOperatingStatements?.find(
                c =>
                    c.field === state.highlightedCell?.colId ||
                    (c.children?.some(
                        child => child.field === state.highlightedCell?.colId,
                    ) ??
                        false),
            )?.headerName ?? "";
        const activeColumn =
            state.extractionStandardizedActiveColumns?.[columnGroup];

        const colIdSplitted = state.highlightedCell?.colId?.split("-");
        const test = colIdSplitted?.slice(0, -1);
        const temp = colIdSplitted.slice(-1);
        const test2 = test?.join("-");
        let isCurrentUpload = false;
        if (test2?.endsWith("id")) {
            isCurrentUpload = true;
        }
        const fileName = state.extractionsInfo?.find(e =>
            isCurrentUpload
                ? e.extractionId === currentUploadExtractionId
                : e.extractionId === Number(temp),
        )?.fileName;
        const status =
            activeColumn?.to ===
            (isCurrentUpload ? currentUploadExtractionId : Number(temp))
                ? "active"
                : "inactive";
        return {
            fileName: fileName ?? "",
            columnGroup: columnGroup,
            status: status,
            currentUpload: isCurrentUpload,
        };
    };
